import { css } from '@emotion/core'
import { smallOnly } from 'Utils'
import theme from 'Theme'

const { mixins, layout } = theme

const { mainContainerTopPadding } = mixins
const {
  maxWidth: { article: maxArticleWidth }
} = layout

export default () => css`
  ${mainContainerTopPadding(theme)}
  max-width: ${maxArticleWidth}px;
  margin-left: auto;
  margin-right: auto;
  min-height: 100vh;

  .heading-load,
  .category-load,
  .hero-image-load {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }

  .hero-image-load {
    height: 500px;
    @media ${smallOnly} {
      height: 250px;
    }
    div {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      height: 500px;
      width: ${layout.maxWidth.article}px;
      ${mixins.loadingLight(theme)}
      @media ${smallOnly} {
        height: 250px;
        width: 100%;
      }
    }
  }

  .writing-load {
    @media ${smallOnly} {
      margin: 2rem auto 1rem;
      width: 95%;
      div {
        margin: 1rem auto;
        height: 25px;
        width: 100%;
        ${mixins.loadingLight(theme)}
        &:last-of-type {
          width: 40%;
          margin-left: 0;
        }
      }
    }
  }

  .category-load {
    width: 96px;
    height: 32px;
    display: block;
    margin: 0px auto 20px;

    div {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      top: 5px;
      height: 20px;
      width: 150px;
      ${mixins.loadingLight(theme)}
    }
    @media ${smallOnly} {
      width: 50%;
    }
  }

  .heading-load {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    height: 50px;
    margin-bottom: 40px;
    @media ${smallOnly} {
      height: 90px;
      margin-bottom: 1rem;
    }
    div {
      display: none;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      height: 50px;
      width: calc(${layout.maxWidth.article}px * 0.8);
      ${mixins.loadingLight(theme)}
      &:first-of-type {
        margin: 1rem auto;
        display: block;
        height: 50px;
        @media ${smallOnly} {
          height: 30px;
          width: 70%;
          margin: 1rem auto 3px;
        }
      }
      @media ${smallOnly} {
        display: block;
        margin: 3px auto;
        height: 32px;
        width: 98%;
      }
    }
  }
`
